module.exports = __webpack_public_path__ + "static/media/ArrowUp.6b1d16ea.svg";